

/**
 *
 */
function getInitialValueForRowSelected() {
    return { rowsData: [], rowIds: {} };
}

export default getInitialValueForRowSelected;